import script from "./DecorationPlacement.vue?vue&type=script&setup=true&lang=ts"
export * from "./DecorationPlacement.vue?vue&type=script&setup=true&lang=ts"

import "./DecorationPlacement.vue?vue&type=style&index=0&id=11b3adf1&lang=css"

const __exports__ = script;

export default __exports__